import { ReactNode } from "react-router/node_modules/@types/react";
import create from "zustand";

type PopupType = "top" | "right" | "bottom" | "left";
type popupInfo = {
  top: number;
  left: number;
  type: PopupType;
  tooltipText: ReactNode;
} | null;

interface Popup {
  popupInfo: popupInfo;
  setPopupInfo: (values: popupInfo | null) => void;
  show: boolean;
  setShow: (value: boolean) => void;
}

export const usePopup = create<Popup>(set => ({
  popupInfo: null,
  setPopupInfo: values =>
    set(() => ({
      popupInfo: values,
    })),
  show: false,
  setShow: value => set(() => ({ show: value })),
}));
